import { withStyles } from "@material-ui/core/styles";

const GlobalCss = withStyles({
  "@global": {
    "*": {
      margin: 0,
      padding: 0,
      outline: 0,
      boxSizing: "border-box",
    },

    html: {
      width: "100vw",
      height: "100vh",
      maxWidth: "100%",

      "& body": {
        height: "100%",
      },
    },

    a: {
      color: "inherit",
      textDecoration: "none",
    },
  },
})(() => null);

export default GlobalCss;
